import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandsSeparator'
})
export class ThousandsSeparatorPipe implements PipeTransform {
  transform(value:number | string): string {
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numberValue)) {
      return '';
    }

    // Formatear el número con separadores de mil
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
}
